module.exports = __webpack_public_path__ + "img/thumbnail_Aardvark_j_normal.27482c93.png";